import Compressor from "compressorjs";
import React, {FormEventHandler} from "react";
import {FileInput, FileInputProps} from "@telegram-apps/telegram-ui";

export interface CompressedImageInputProps extends FileInputProps {
    onChange: FormEventHandler<HTMLInputElement> | undefined;
    id: string;
    onCompressError?: (err: Error) => void | undefined;
}

const CompressedImageInput = ({ onCompressError, onChange, id, ...restProps }: CompressedImageInputProps) => {
    const handleChange = async (event: React.FormEvent<HTMLInputElement>) => {
        if (!event.target) {
            return;
        }
        const target = event.target as HTMLFormElement;
        const imageObj = target.files[0];
        new Compressor(imageObj, {
            quality: 0.6,
            maxHeight: 1000,
            maxWidth: 1000,
            success(result) {
                let file = new File([result], imageObj.name, { type: result.type });
                let container = new DataTransfer();
                container.items.add(file);
                if (!id) {
                    return;
                }
                const input = document.getElementById(id) as HTMLFormElement;
                input.files = container.files;

                if (onChange) {
                    onChange(event);
                }
            },
            error(err) {
                console.log(err.message);
                if (onCompressError) {
                    onCompressError(err);
                }
                if (onChange) {
                    onChange(event);
                }
            },
        });
    };

    return <FileInput
        id={id}
        onChange={handleChange}
        {...restProps}
    />;
}

export default CompressedImageInput;